let TaskUtil = {
    /**
     * 将任务堆栈的数据复制一份给Vue使用
     */
    taskStack2Task(taskStack) {
        let task = JSON.parse(JSON.stringify(taskStack))
        task.src = taskStack.src; // 只操作拷贝的task 保存原task引用
        task.remainingHour = task.duration;
        task.duration = 0;
        task.startTime = new Date(task.startTime)
        task.endTime = new Date(task.startTime)
        task.isStart = true
        task.isEnd = false
        return task;
    },
    log(task) {
        let log = JSON.stringify({
            title: task.title,
            start: task.startTime && task.startTime.Format(),
            end: task.endTime && task.endTime.Format(),
        }, null, "\t")
        console.log('task', log)
    }
}
export default TaskUtil
